var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLightingWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8553 14.0375L30.6611 11.2711V9.48385H30.0024V6H19.5133L19.5024 3.49219H16.5024V6.00692H6.00244V9.48385H5.34271V11.2711L2.1488 14.0373C1.94172 14.2161 1.86825 14.4922 1.96084 14.7409C2.06425 15.0178 2.34646 15.1969 2.67968 15.1969H11.015C11.3482 15.1969 11.6304 15.0178 11.7341 14.7403C11.8262 14.4922 11.7524 14.2161 11.5464 14.0375L8.35226 11.2717V9.48413H7.50244V7.5H16.5024V33.4922H19.5133V7.5H28.4663V9.48385H27.6521V11.2711L24.4582 14.0373C24.2511 14.2161 24.1776 14.4922 24.2699 14.7403C24.3731 15.0175 24.6553 15.1969 24.9891 15.1969H33.3241C33.6579 15.1969 33.9401 15.0175 34.0429 14.7409C34.1355 14.4922 34.0618 14.2161 33.8553 14.0375Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLightingWhite);
export default __webpack_public_path__ + "static/media/no-lighting-white.c084ca15c2fac9e999f55e0df1f8fa27.svg";
export { ForwardRef as ReactComponent };